import type { OverWritable } from '../../@types/settings';

export const stepper: OverWritable = {
  MuiStepConnector: {
    styleOverrides: {
      line: ({ theme }) => ({
        borderColor: theme.palette.divider,
      }),
    },
  },
};
